/* src/app/components/identity/manage-password/manage-password.component.scss */
:host-context(.dark-theme) .set-password-button.mat-mdc-raised-button.mat-primary {
  background-color: #D0A010;
  color: rgba(0, 0, 0, 0.87);
}
:host-context(.dark-theme) .set-password-button.mat-mdc-raised-button.mat-primary:disabled {
  background-color: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.3);
}
:host-context(.dark-theme) :host ::ng-deep .mat-mdc-input-element {
  caret-color: #b18a16;
}
/*# sourceMappingURL=manage-password.component.css.map */
